<template>
  <div class="linkage-carOperate-list">
    <base-list-management ref="baseListManagement" :configData.sync="configData">
      <div slot="custom-export">
        <el-button @click="exportData" v-if="judgePermission('carOperateExport')">导出数据</el-button>
        <el-button @click="exportList" v-if="judgePermission('carOperateExportList')">导出列表</el-button>
      </div>
    </base-list-management>
    <ExportListDialog
      @init="handleExportListDialogInit"
      :dialogVisible="listShow"
      :taskType="3"
      fileName="车辆运营"
      @close="() => this.listShow = false"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { getVehicleOperateList, exportVehicleOperateList } from '@/api/domain/vehicle'
import { getShareList } from '@/api/domain/organize'
import {
  ONLINE_RIDE_STATUS_MAP,
  ONLINE_RIDE_STATUS_LIST,
  WORK_STATUS_MAP,
  WORK_STATUS_LIST,
  NO_WORK_REASON_MAP,
  NO_WORK_REASON_LIST,
  WORK_RATE_LIST,
  WORK_DURATION_LIST,
  TPH_LIST,
} from './config'
import ExportListDialog from '@/bizComponents/ExportListDialog/index.vue'
import {
  getAllBrand,
  getSeriesListByBrand,
} from '@/api/carModel.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  components: {
    ExportListDialog,
  },
  data() {
    return {
      configData: {
        formData: {
          list: [
            {
              el: 'select',
              itemConfig: {
                label: '品牌',
                prop: 'brandId',
              },
              elConfig: {
                events: {
                  change: this.handleBrandIdChange,
                  clear: this.handleBrandIdClear,
                },
                options: {
                  label: 'brandName',
                  value: 'brandId',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '车系',
                prop: 'seriesId',
                ref: 'seriesId',
              },
              elConfig: {
                disabled: true,
                options: {
                  label: 'seriesName',
                  value: 'seriesId',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '网约注册平台',
                prop: 'spId',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日网约状态',
                prop: 'yesterdayOnlineRideStatus',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: ONLINE_RIDE_STATUS_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日出车状态',
                prop: 'yesterdayWorkStatus',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_STATUS_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日不可出车原因',
                prop: 'noWorkReason',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: NO_WORK_REASON_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '本周出车率',
                prop: 'weekWorkRate',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_RATE_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '本月出车率',
                prop: 'monthWorkRate',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_RATE_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日出车时长',
                prop: 'yesterdayWorkDuration',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_DURATION_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '车辆昨日TPH',
                prop: 'yesterdayTPH',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: TPH_LIST,
                },
              },
            },
          ],
          customizeReset: this.customizeReset,
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                label: '序号',
                prop: 'id',
              },
              render: ({ $index }) => `${$index + 1}`,
            },
            {
              name: 'carId',
              columnProps: {
                label: '车辆ID',
                prop: 'carId',
              },
            },
            {
              name: 'plateNo',
              columnProps: {
                label: '车牌号',
                prop: 'plateNo',
                width: 100,
              },
            },
            {
              name: 'carBrand',
              columnProps: {
                label: '品牌',
                prop: 'carBrand',
              },
            },
            {
              name: 'carSeries',
              columnProps: {
                label: '车系',
                prop: 'carSeries',
              },
            },
            {
              name: 'carModel',
              columnProps: {
                label: '车型',
                prop: 'carModel',
                width: 160,
              },
            },
            {
              name: 'rentedDays',
              columnProps: {
                label: '车辆累计已租天数',
                prop: 'rentedDays',
              },
            },
            {
              name: 'spName',
              columnProps: {
                label: '网约注册平台',
                prop: 'spName',
              },
            },
            {
              name: 'yesterdayOnlineRideStatus',
              columnProps: {
                label: '昨日网约状态',
                prop: 'yesterdayOnlineRideStatus',
              },
              render: ({ row }) => (ONLINE_RIDE_STATUS_MAP[row.yesterdayOnlineRideStatus]?.name || '--'),
            },
            {
              name: 'yesterdayWorkStatus',
              columnProps: {
                label: '昨日出车状态',
                prop: 'yesterdayWorkStatus',
              },
              render: ({ row }) => (WORK_STATUS_MAP[row.yesterdayWorkStatus]?.name || '--'),
            },
            {
              name: 'yesterdayNoWorkReason',
              columnProps: {
                label: '昨日不可出车原因',
                prop: 'yesterdayNoWorkReason',
              },
              render: ({ row }) => (NO_WORK_REASON_MAP[row.yesterdayNoWorkReason]?.name || '--'),
            },
            {
              name: 'yesterdayWorkStatusDuration',
              columnProps: {
                width: 120,
                label: '昨日出车时长(小时)',
                prop: 'yesterdayWorkStatusDuration',
              },
            },
            {
              name: 'yesterdayPeakWorkDurationProportion',
              columnProps: {
                label: '昨日高峰出车时长占比',
                prop: 'yesterdayPeakWorkDurationProportion',
              },
              render: ({ row }) => {
                if (row.yesterdayPeakWorkDurationProportion !== null) {
                  return `${(row.yesterdayPeakWorkDurationProportion * 100).toFixed(2)}%`
                }
                return '--'
              },
            },
            {
              name: 'yesterdayServiceDurationProportion',
              columnProps: {
                label: '昨日服务时长占比',
                prop: 'yesterdayServiceDurationProportion',
              },
              render: ({ row }) => {
                if (row.yesterdayServiceDurationProportion !== null) {
                  return `${(row.yesterdayServiceDurationProportion * 100).toFixed(2)}%`
                }
                return '--'
              },
            },
            {
              name: 'weekWorkRate',
              columnProps: {
                label: '本周出车率',
                prop: 'weekWorkRate',
              },
            },
            {
              name: 'monthWorkRate',
              columnProps: {
                label: '本月出车率',
                prop: 'monthWorkRate',
              },
            },
            {
              name: 'yesterdayTPH',
              columnProps: {
                label: '车辆昨日TPH(单/小时)',
                prop: 'yesterdayTPH',
              },
            },
            {
              name: 'weekTPH',
              columnProps: {
                label: '车辆本周TPH(单/小时)',
                prop: 'weekTPH',
              },
            },
            {
              name: 'monthTPH',
              columnProps: {
                label: '车辆本月TPH(单/小时)',
                prop: 'monthTPH',
              },
            },
            {
              name: 'yesterdayIncomeIPH',
              columnProps: {
                label: '车辆昨日IPH(元/小时)',
                prop: 'yesterdayIncomeIPH',
              },
            },
            {
              name: 'weekIncomeIPH',
              columnProps: {
                label: '车辆本周IPH(元/小时)',
                prop: 'weekIncomeIPH',
              },
            },
            {
              name: 'monthIncomeIPH',
              columnProps: {
                label: '车辆本月IPH(元/小时)',
                prop: 'monthIncomeIPH',
              },
            },
          ],
          attrs: {
            'span-method': this.objectSpanMethod,
          },
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getVehicleOperateList,
        },
      },
      listShow: false,
      exportListDialogApi: {},
    }
  },
  methods: {
    handleExportListDialogInit(exportListDialogApi) {
      this.exportListDialogApi = exportListDialogApi
    },
    // 合并单元格
    // 合并范围：前7列
    // 合并逻辑：如果当前行的carId等于前一行的carId则累计计数器，否则重置计数器
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (row && columnIndex <= 6) {
        const tableData = this.$refs.baseListManagement.$refs.baseTable.list
        if (rowIndex === 0 || row.carId !== tableData[rowIndex - 1].carId) {
          let rowspan = 0
          tableData.forEach((item) => {
            if (item.carId === row.carId) {
              rowspan++
            }
          })
          return [rowspan, 1]
        } else {
          return [0, 0]
        }
      }
      return [1, 1]
    },
    customizeReset() {
      this.resetFieldSeriesId()
    },
    // 获取网约平台列表
    async getShareList() {
      const { code, data } = await getShareList()

      if (code === 1) {
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'spId', data: data || [] })
      }
    },
    // 获取车辆品牌列表
    async getBrandList() {
      const { code, data } = await getAllBrand({ modelFilterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK })

      if (code === 1) {
        const result = [{ brandName: '全部', brandId: '' }].concat(data || [])
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'brandId', data: result })
      }
    },
    // 获取车辆车系列表
    async getSeriesList(val) {
      const { code, data } = await getSeriesListByBrand({
        brandId: val,
        modelFilterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
      })

      if (code === 1) {
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'disabled', key: 'seriesId', data: false })
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'seriesId', data: data || [] })
      }
    },
    handleBrandIdChange(val) {
      if (val) {
        this.$refs.baseListManagement.getRefs({ type: 'form', formItemRef: 'seriesId' }).resetField()
        this.getSeriesList(val)
      }
    },
    handleBrandIdClear() {
      this.$refs.baseListManagement.getRefs({ type: 'form', formItemRef: 'seriesId' }).resetField()
      this.resetFieldSeriesId()
    },
    resetFieldSeriesId() {
      this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'seriesId', data: [] })
      this.$refs.baseListManagement?.setItemData({ elConfigKey: 'disabled', key: 'seriesId', data: true })
    },
    getRouteQuery() {
      const {
        spId,
        yesterdayWorkStatus,
        noWorkReason,
        weekWorkRate,
        monthWorkRate,
        yesterdayWorkDuration,
        yesterdayTPH,
      } = this.$route.query

      // 网约注册平台
      if (typeof spId !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'spId', Number(spId))
      }
      // 昨日出车状态
      if (typeof yesterdayWorkStatus !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'yesterdayWorkStatus', Number(yesterdayWorkStatus))
      }
      // 昨日不可出车原因
      if (typeof noWorkReason !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'noWorkReason', Number(noWorkReason))
      }
      // 本周出车率
      if (typeof weekWorkRate !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'weekWorkRate', Number(weekWorkRate))
      }
      // 本月出车率
      if (typeof monthWorkRate !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'monthWorkRate', Number(monthWorkRate))
      }
      // 昨日出车时长
      if (typeof yesterdayWorkDuration !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'yesterdayWorkDuration', Number(yesterdayWorkDuration))
      }
      // 车辆昨日TPH
      if (typeof yesterdayTPH !== 'undefined') {
        this.$set(this.configData.formData.formProps.model, 'yesterdayTPH', Number(yesterdayTPH))
      }
    },
    // 导出数据
    async exportData() {
      const params = this?.$refs?.baseListManagement?.$refs?.searchForm?.getSearchParams() || {}
      const { code } = await exportVehicleOperateList(params)
      if (code !== 1) return
      this.$message.success('所选数据已生成下载文件，请点击【导出列表】查看下载')
    },
    // 导出列表
    exportList() {
      this.listShow = true
      const { getTableData } = this.exportListDialogApi
      getTableData && getTableData()
    },
  },
  created() {
    this.getShareList()
    this.getBrandList()
  },
  mounted() {
    this.getRouteQuery()
  },
}
</script>
